import gql from 'graphql-tag';

export const GetINTLLoyaltyIdByEmail = gql`
  query intlLoyaltyIdByEmail($email: String!) {
    intlLoyaltyIdByEmail(email: $email)
  }
`;
